export const adoptionProfileModelData = function () {
  return {
    success: null,
    adoptionProfileList: []
  }
}
